import { bankApi } from '@/api/index'
import { SecureTransactionType } from '@/domains/SecureConfirmDomain'

const BASE = '/secure-confirmation'

export interface IGenerateSecureConfirmationMessageResponse {
  content: string
  locale: string
  title: string
}

export const fetchSecureConfirmMessage = <P>(
  secureTransaction: SecureTransactionType,
  payload: P,
): Promise<IGenerateSecureConfirmationMessageResponse> => {
  return bankApi.post(`${BASE}/${secureTransaction}`, payload)
}
